import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // useRef guard: one-time session exchange, safe under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data);
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    exchange();
  }, [location.hash, navigate, setUser]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-4">
      <div className="w-10 h-10 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin" />
      <p className="text-slate-600 text-sm">Connexion en cours…</p>
    </div>
  );
}
